module.exports = __webpack_public_path__ + "img/afe2985.jpg";